import { render, staticRenderFns } from "./Sustainability.vue?vue&type=template&id=71ef3dae&scoped=true"
import script from "./Sustainability.vue?vue&type=script&lang=js"
export * from "./Sustainability.vue?vue&type=script&lang=js"
import style0 from "./Sustainability.vue?vue&type=style&index=0&id=71ef3dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef3dae",
  null
  
)

export default component.exports